export default __webpack_public_path__ + "images/5bb69d8a8050994c3ee00d53300e3425.svg";